<template>
	<!-- 监理月报 -->
	<div class="mod-config">
		<el-row>
			<!-- <el-col :span="1" style="border:1px solid transparent"></el-col> -->
			<el-col :span="24" style="margin-top:-10px">
				<el-card body-style="padding-bottom: 0;" style="margin-top: 5px;">
					<el-row class="title_color">
						<el-col :span="20">
							<div class="title">监理月报</div>
						</el-col>
						<el-col :span="4" style="margin-top:10px;margin-bottom:-10px">
							<i class="el-icon-sort" id="PointerIcon" style="right:1rem;transform:rotate(90deg);" @click="goBack()"></i>
							<el-button v-preventReClick type="text" @click="goBack()" class="backbtn">返回门户</el-button>
						</el-col>
					</el-row>
				</el-card>
				<div>
					<el-card style="margin-top: -3px; " body-style="padding: 0;">
						<el-row style="margin-bottom: 10px;">
							<el-col :span="24">
								<div class="box">
									<el-table :height="screenHeight - 110 + 'px'" :row-class-name="tableRowClassName" class="dataListTable" border
										:data="dataList" header-align="center" style="width: 100%;margin-bottom: 20px;"
										header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
										<el-table-column type="index" label="NO." width="60" align="center">
											<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1
											}}</template>
										</el-table-column>
										<el-table-column prop="monthlyName" label="月报编号" min-width="250" align="center">
											<template slot-scope="scope">
												<el-button v-preventReClick type="text" size="small"
													@click="viewPdf(scope.row.finalFilePath, scope.row.weeklyName)">{{
														scope.row.monthlyName}}</el-button>
											</template>
										</el-table-column>
										<el-table-column prop="beginTime" label="开始日期" width="250" align="center">
										</el-table-column>
										<el-table-column prop="endTime" label="截止日期" width="250" align="center">
										</el-table-column>
										<!-- <el-table-column label="日期" min-width="200" align="center">
											<template slot-scope="scope">
												{{ scope.row.beginTime }} ~~ {{ scope.row.endTime }}
											</template>
										</el-table-column> -->
										<el-table-column prop="insDate" label="制作日期" width="200" align="center">
										</el-table-column>
										<el-table-column label="操作" width="80" fixed="right" align="center">
											<template slot-scope="scope">
												<el-button v-preventReClick type="text" size="small"
													@click="downloadHandle(scope.row.recNo)">附件查看</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>
								<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
									@current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]"
									:page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
								</el-pagination>
							</el-col>
						</el-row>
					</el-card>
				</div>
			</el-col>
		</el-row>
		<monthly-export v-if="exportVisible" ref="monthlyExport" @refreshDataList="getDataList"></monthly-export>
		<monthly-report-download v-if="downloadVisible" ref="monthlyReportDownload"
			@refreshDataList="getDataList"></monthly-report-download>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
	</div>
</template>
<script>
import ViewPdf from "../projectInfo/viewPdf.vue"
import $common from "@/utils/common.js"
import MonthlyExport from './monthly-export'
import MonthlyReportDownload from "./monthly-report-download.vue"
export default {
	data() {
		return {
			viewPdfVisible: false,
			showSearch: false,
			showDownload: false,
			showAdd: false,
			showEdit: false,
			showDelete: false,
			showCheck: false,
			showArchive: false,
			showCreateFile: false,
			showRowDownload: false,
			pageSpan: 12,
			exportVisible: false,
			downloadVisible: false,
			form: {},
			dataList: [],
			tableSelVal: [],
			//当前页码
			pageIndex: 1,
			// 显示序号
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			screenHeight: 0,
		};
	},
	components: {
		MonthlyExport,
		MonthlyReportDownload,
		ViewPdf
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.showSearch = $common.isAuth('monthly:search');
		this.showDownload = $common.isAuth('monthly:download');
		this.showAdd = $common.isAuth('monthly:add');
		this.showEdit = $common.isAuth('monthly:edit');
		this.showDelete = $common.isAuth('monthly:delete');
		this.showCheck = $common.isAuth('monthly:check');
		this.showArchive = $common.isAuth('monthly:archive');
		this.showCreateFile = $common.isAuth('monthly:createFile');
		this.showRowDownload = $common.isAuth('monthly:download');
		if (!this.showSearch && !this.showDownload && !this.showAdd) {
			this.pageSpan = 24;
		}
		this.getDataList();
	},
	methods: {
		selectFile(url) {
			window.open(url);
		},
		//重置
		resetFormData() {
			this.pageIndex = 1;
			this.getDataList();
		},
		// 获取数据列表
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/monthlyreportinfo/list",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					limit: this.pageSize,
					subjectNo: $common.getItem("subjectNo"),
					workNo: $common.getItem("workNo"),
					refirmFlg: '1'
				})
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataList = data.body.records;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				} else {
					this.dataList = []
					this.totalPage = 0
					this.pageIndex2 = 1
				}
			})
		},
		viewPdf(filePath, filename) {
			// $common.viewFile(filePath)
			if(filePath == null || filePath == undefined || filePath == '') {
				this.$message.error("没有可预览的文件！");
				return;
			} 
			this.viewPdfVisible = true;
			this.$nextTick(() => {
				this.$refs.viewPdf.init(filename, filePath)
			})
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val
			this.getDataList()
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 160;
			return { height: height + 'px' }
		},
		tableRowClassName({ row, rowIndex }) {
			let color = ''
			for (let item of this.tableSelVal) {
				if (item.id === row.id) color = 'table-SelectedRow-bgcolor'
			}
			return color
		},
		downloadHandle(id) {
			this.downloadVisible = true;
			this.$nextTick(() => {
				this.$refs.monthlyReportDownload.init(id)
			})
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		goBack() {
			this.$router.push({ name: 'workbench' });
		}
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.my-pagination {
	margin-left: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}

.title_color {
	height: 60px !important;
}
</style>
